import {UserSortField as UserSortFields} from 'src/openapi/admin/models/UserSortField';

import {COLUMNS, LOADING_PRIORITY} from './constants';

import type {UserSearchCriteria} from 'src/openapi/admin/models/UserSearchCriteria';
import type {UserSearchFiltering} from 'src/openapi/admin/models/UserSearchFiltering';
import type {UserSortField} from 'src/openapi/admin/models/UserSortField';

export const checkShouldLoadColumn = (columnId: string, selectedColumns: string[]) => {
    const relation = LOADING_PRIORITY.find(rel => rel.columnId === columnId);
    if (!relation) {
        return false;
    }

    return !LOADING_PRIORITY
        .filter(column => selectedColumns.includes(column.columnId))
        .some(other => (
            other.columnId !== columnId &&
            other.chunk === relation.chunk &&
            other.priority > relation.priority
        ));
};

export const getMappedLimitColumnId = (columnId: string) => (
    Object.entries(COLUMNS).find(([, value]) => value === columnId)?.[0] || ''
);

export const mapColumnIdToUserSortField: (columnId: string) => UserSortField = columnId => {
    switch (columnId) {
        case COLUMNS.EMAIL:
            return UserSortFields.EMAIL;
        case COLUMNS.USER_ID:
            return UserSortFields.ID;
        case COLUMNS.ACCOUNT_ID:
            return UserSortFields.ACCOUNT_NAME;
        case COLUMNS.GROUP_ID:
            return UserSortFields.GROUP_NAME;
        case COLUMNS.FIRST_NAME:
            return UserSortFields.FIRST_NAME;
        case COLUMNS.LAST_NAME:
            return UserSortFields.LAST_NAME;
        case COLUMNS.TYPE:
            return UserSortFields.TYPE;
        case COLUMNS.STATUS:
            return UserSortFields.STATUS;
        case COLUMNS.JOB_TITLE:
            return UserSortFields.JOB_TITLE;
        case COLUMNS.COUNTRY:
            return UserSortFields.COUNTRY;
        case COLUMNS.STATE:
            return UserSortFields.STATE;
        case COLUMNS.PROVINCE:
            return UserSortFields.PROVINCE;
        case COLUMNS.CITY:
            return UserSortFields.CITY;
        case COLUMNS.DELETED:
            return UserSortFields.DELETED;
        case COLUMNS.ADDRESS_1:
            return UserSortFields.ADDRESS_1;
        case COLUMNS.ADDRESS_2:
            return UserSortFields.ADDRESS_2;
        case COLUMNS.WORK_PHONE:
            return UserSortFields.WORK_PHONE;
        case COLUMNS.MOBILE_PHONE:
            return UserSortFields.MOBILE_PHONE;
        case COLUMNS.POSTAL_CODE:
            return UserSortFields.POSTAL_CODE;
        case COLUMNS.FIRST_LICENSE_DATE:
            return UserSortFields.FIRST_LICENSED;
        case COLUMNS.LAST_PLATFORM_ACTIVITY:
            return UserSortFields.LAST_PLATFORM_ACTIVITY;
        case COLUMNS.TEMPLATE_USER:
            return UserSortFields.TEMPLATE_USER;
        case COLUMNS.ACCOUNT_TEAM_MEMBER:
            return UserSortFields.ACCOUNT_TEAM_MEMBER;
        case COLUMNS.SAVED_SEARCHES:
            return UserSortFields.SAVED_SEARCHES;
        case COLUMNS.CREATOR:
            return UserSortFields.CREATOR;
        case COLUMNS.CREATED_DATE:
            return UserSortFields.CREATED_DATE;
        case COLUMNS.LAST_MODIFIER:
            return UserSortFields.LAST_MODIFIER;
        case COLUMNS.LAST_MODIFIED_DATE:
            return UserSortFields.LAST_MODIFIED_DATE;
        case COLUMNS.LAST_MODIFICATION_REASON:
            return UserSortFields.LAST_MODIFICATION_REASON;
        case COLUMNS.SALESFORCE_ID:
            return UserSortFields.SALESFORCE_ID;
        case COLUMNS.MS_DYNAMICS_ID:
            return UserSortFields.MS_DYNAMICS_ID;
        case COLUMNS.DEAL_CLOUD_ID:
            return UserSortFields.DEAL_CLOUD_ID;
        case COLUMNS.HUBSPOT_ID:
            return UserSortFields.HUBSPOT_ID;
        default:
            return UserSortFields.EMAIL;
    }
};

export const getSearchFilteringCriteria = (searchCriteria: UserSearchCriteria, filters?: UserSearchFiltering) => {
    return {searchCriteria, filtering: filters};
};
